import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  showDialog() {
    super.showDialog();
    this.#scheduleTermsCleanup();
  }

  #scheduleTermsCleanup() {
    [0, 100, 500, 1500].forEach((delay) => {
      window.setTimeout(() => {
        this.#hideTermsAppInDrawer();
      }, delay);
    });
  }

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  #hideTermsAppInDrawer() {
    const selectors = [
      '#shopify-block-16735461377607925125',
      '[id*="terms-and-conditions-in-cart"]',
      '[class*="terms-and-conditions-in-cart"]',
      '[id*="terms_and_conditions"]',
      '[class*="terms_and_conditions"]',
      '.agree-to-terms',
      '#agree_terms_and_conditions',
    ];

    this.querySelectorAll(selectors.join(',')).forEach((element) => {
      if (element.closest('.cart__legal-footer')) return;
      element.remove();
    });

    this.querySelectorAll('a[href*="terms"]').forEach((link) => {
      if (link.closest('.cart__legal-footer')) return;

      const container = link.closest('p, div, .shopify-app-block, label');
      const text = container?.textContent?.toLowerCase() ?? '';

      if (text.includes('terms and conditions') || text.includes('clicking checkout')) {
        container?.remove();
      }
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
